
import {Task} from './task';
import {Lab} from './lab';


export const LABS: Lab[] = [

    new Lab(1, '开发前的准备','完成如下操作',10,[

      new Task(1,'初始前端技术.','<h3>请结合浙江省精品在线开放课程的视频,展开如下讨论：</h3>' +
      '<ol><li>常用的前端技术有哪些主流框架</li><li>常用的前端技术有哪些开发工具</li><li>从政治和技术角度，试讨论如何推动和增强国产工具和技术的发展</li></ol>',5),
      new Task(2,'创建开发环境',''+
      '<div class="panel panel-default">\n' +
      '  <div class="panel-heading">\n' +
      '    <h3 class="panel-title">魔法学堂</h3>\n' +
      '  </div>\n' +
      '  <div class="panel-body">\n' +
      '    <div class="row">\n' +
      '       <div class="col-md-12"><h4>按教材要求，结合视频，完成Hbuilder软件的安装</h4></div> \n' +
   
      '        <div class="col-md-12"> <img src="https://tva1.sinaimg.cn/large/e6c9d24ely1h5awv5da9hj21hc0ts42g.jpg" width="100%"></div>'+
      '    </div>'+
      '  </div>\n' +
      '</div>',5),
      new Task(3,'使用开发工具.','<h4>请使用HBuilder开发工具，完成下列Emmet语法练习</h4>'+
      '<img src="https://tva1.sinaimg.cn/large/e6c9d24ely1h59oiak52lj20n90fj3z0.jpg" width=400 ><hr>'+
      '<img src="https://tva1.sinaimg.cn/large/e6c9d24ely1h59otcv9uvj20ro0igdh0.jpg" width=400 ><hr>'+
      '<img src="https://tva1.sinaimg.cn/large/e6c9d24ely1h59p3rxou7j20l00e00te.jpg" width=400 >'       
      ,5)
    ]),
    new Lab(2, '网页文字制作','完成如下操作',10,[

      new Task(1,'认识网页标签:HTML',''+
      '<div class="panel panel-default">\n' +
      '  <div class="panel-heading">\n' +
      '    <h3 class="panel-title">课堂讨论</h3>\n' +
      '  </div>\n' +
      '  <div class="panel-body">\n' +
      '    <div class="row">\n' +
      '       <div class="col-md-12"><h4>请结合下面页面效果，要实现该页面，需要用到哪些HTML标签？</h4></div> \n' +
  
      '    <div class="col-md-12">     <img src="https://tva1.sinaimg.cn/large/e6c9d24ely1h5axjoa547j20ik0ol763.jpg" width="100%"></div>'+
      '    </div>'+
      '  </div>\n' +
      '</div>',5),
      new Task(2,'搭建页面骨架-文档结构标签',''+
      '<div class="panel panel-default">\n' +
      '  <div class="panel-heading">\n' +
      '    <h3 class="panel-title">魔法学堂</h3>\n' +
      '  </div>\n' +
      '  <div class="panel-body">\n' +
      '    <div class="row">\n' +
      '       <div class="col-md-12"><h4>仔细观察如下效果图结构，使用HTML5的文档标签，搭建HTML骨架</h4></div> \n' +
  
      '    <div class="col-md-12">     <img src="https://tva1.sinaimg.cn/large/e6c9d24ely1h5awz4pi4rj20v60u0jxj.jpg" width="100%"></div>'+
      '    </div>'+
      '  </div>\n' +
      '</div>',5),
      // new Task(3,'丰富页面的表达-使用图片','描述2',5),
      // new Task(4,'神奇的跳转——链接和锚点的使用','描述2',5),
      // new Task(5,'列表和特殊标记的使用','描述2',5)
    ]),
    new Lab(3, 'CSS美化页面','完成如下操作',10,[

      new Task(1,'美化页面神器——CSS基本语法','<h3>请根据如下指令完成课堂练习</h3>' +
        '<ol><li>创建一个包含三个列表项的无序列表</li><li>使用标签选择器选择所有元素将其字体颜色变红</li><li>使用id选择器将第2个标签字体变蓝</li><li>使用类选择器将第1,3列表项变成绿色</li><li>将样式代码迁移到外部样式中</li><li>对第二个列表项添加内联样式，将字体变成60px</li></ol>',5),
      new Task(2,'布局方寸之间——盒子模型和背景属性','<h4>1.请用sublime工具，根据下图效果完成html和css样式设计，css采用内嵌式写在同一个html文档中，请将完整的页面代码写在答案栏中</h4><img src="http://image.moocollege.com/v2_editor/image/5TwBWdD-FPyM7QTJh9k1IirNi446xW85Tu2ypMzNkPIjug7ov-Uf3nYLhdibux8K_1509451039852.png"> ' +
        '<h4>2.使用背景图相关样式和属性，实现如下页面背景效果</h4><img src="http://ww2.sinaimg.cn/large/6d025b55ly1g6714ld29mj20iw09wmyg.jpg"> ',5),
      new Task(3,'挑战CSS魔法——高级选择器','<h4>请根据下面的页面结构，依次完成下列任务,将选中的元素变成<b>红色</b></h4><ol>' +
        '<li>使用id选择器选中<b>香蕉</b></li>' +
        '<li>使用class选择器选中<b>香蕉</b>和<b>哈密瓜</b></li>' +
        '<li>使用并集（群组)选择器选中<b>香蕉</b>和<b>哈密瓜</b></li>' +
        '<li>使用后代选择器（上下文选择器）选中<b>苹果</b></li>' +
        '<li>使用子代选择器选中<b>网页制作</b></li>' +
        '<li>使用兄弟选择器选中<b>Java程序设计</b></li>' +
        '</ol>' +
        '<img src="http://ww2.sinaimg.cn/large/6d025b55ly1g671zaixuvj208o07e0sp.jpg"> ',5),
      new Task(4,'编码加速器——Emmet语法','<h4>1.请在你熟悉的开发工具中，使用Emmet插件完成如下指令：</h4>' +
        '<ol>' +
          '<li>.wrap>ul.list>.sites</li>'+
          '<li>.outer>.inner>h1+p</li>'+
          '<li>.wrap>p>a^p</li>'+
          '<li>.wrap>p>a^p</li>'+
          '<li>.wrap>p>em>a^^p</li>'+
          '<li>(.one>h1)+(.two>h1)</li>'+
          '<li>a["www.baidu.com"]+p{this is paragraph}</li>'+
          '<li>ul>li*3</li>'+
          '<li>ul>li.item${item$$}*3</li>'+
          '<li>h2>lorem4</li>'+
        '</ol>'+
        '<h4>2.请使用Emmet语法生成如下页面的代码结构</h4><img  src="http://ww4.sinaimg.cn/large/6d025b55ly1g57v0eq2qcj20ku112qpf.jpg" >',5),
      new Task(5,'边框线的魔幻之旅','' +
        '<h4>请按照如下操作变出魔法</h4>' +
        '<ul>' +
          '<li>绘制一个100*20的div盒子，并使用边框线</li>'+
          '<li>去除盒子的内容文字</li>'+
          '<li>将边框线加粗为48</li>'+
          '<li>使用红，绿，蓝，黄定义四条边的不同颜色</li>'+
          '<li>保留需要的颜色，其他的边框线变成透明色</li>'+
        '</ul>' +
        '\n' +
        '<div class="panel panel-default">\n' +
        '  <div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '    <div class="row">\n' +
        '       <div class="col-md-6 col-md-offset-4"><img src="http://ww2.sinaimg.cn/large/6d025b55ly1g6739qid0dj206w043glf.jpg" ></div> \n' +
        '       </div>'+
        '  </div>\n' +
        '</div>',5),
      new Task(6,'神奇的幽灵元素——伪类和伪元素','<div class="panel panel-default">\n' +
        '  <div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '    <div class="row">\n' +
        '       <div class="col-md-6 "><h4>1、链接伪类的实现，实现一个链接要求：</h4>' +
        '        <ol>'  +
        '        <li>在link状态下，显示默认浅红色字体，没有下划线</li>' +
        '        <li>在over状态下，显示下划线</li>' +
        '        <li>在active状态下，显示深红色字体</li>' +
        '        <li>在visited状态下，显示蓝色字体</li>' +
        '        </ol>' +
        '       </div>'+
        '  </div>\n' +
        '</div>'+
      '' +
        '  <div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '    <div class="row">\n' +
        '<div class="col-md-6"> <h4>2.请使用伪元素实现如下效果</h4><img src="http://ww3.sinaimg.cn/large/6d025b55ly1g57tm1yd6wg20ew01umz9.gif"> ' +
        '</div></div></div>',5)]),
    new Lab(4, '数据表格应用','完成如下操作',10,[

      new Task(1,'呈现数据的利器——表格.','<h4>请使用表格相关标签实现如下效果</h4><img src="http://ww4.sinaimg.cn/large/6d025b55ly1g58hd97bvbj20dk04ot8o.jpg">',5)
    ]),
    new Lab(5, '表单制作','完成如下操作',10,[

      new Task(1,'构建数据交互——表单的基本控件使用','<h4>请使用表单控件实现如下效果</h4><img src="http://image.moocollege.com/v2_editor/image/-8Ydw59YPGNKohB7HeZSkGQWpEHLlHwa9BTMaklwLxYdLDADahAf1heZgJjLsipJ_1512114951406.png"> ',5),
      new Task(2,'构建数据交互——高级表单制作','<h4>请使用表单控件实现如下效果</h4><img src="http://image.moocollege.com/v2_editor/image/ZscMGMh2G-R4SZ6NaqwKKGH78444fUzMzz1rc4Nn7ygGTaSSmhFkSnlapp-cVh7H_1512457866676.png"> ',5)
    ]),

    new Lab(6, '网页结构布局','完成如下操作',10,[

      new Task(1,'玩转文档排版——浮动','<h4>请使用浮动实现如下效果</h4><img src="http://ww4.sinaimg.cn/large/6d025b55ly1g58gn0m7s3j20qe0nk46m.jpg"> ',5),
      // new Task(2,'京东秒杀背后的故事-定位','<h4>根据小米官网的“明星单品”效果图，给出HTML结构，并审查页面的样式代码，编写和制作CSS样式文件。样式采用内嵌样式写法，并将写好的html打包后上传到空间中来</h4><img src="http://image.moocollege.com/v2_editor/image/8FZocGxCTIrdTsRFQguyJgxvDKcho1hayU22JtGDfBFaJFvXWvKKSRnoRBuS0K-a_1511501426568.png"> ',5)
      new Task(2,'京东秒杀背后的故事-定位','<h4>根据京东官网的秒杀模块效果图，给出HTML结构，并审查页面的样式代码，编写和制作CSS样式文件。样式采用内嵌样式写法，并将写好的html打包后上传到空间中来</h4><img src="http://ww2.sinaimg.cn/large/6d025b55ly1g58h2eqnzsj20nq06owhe.jpg"> ',5)
    ]),
    new Lab(7, '网页高级技术','完成如下操作',10,[


      new Task(1,'使用font-face自定义字体','  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '    <div class="row">\n' +
        '<div class="col-md-6"> <h4>1、请使用font-face自定义字体，完成"精益求精"字体特效：</h4><img src="http://ww4.sinaimg.cn/large/6d025b55ly1g673xxsm4gj208z06fq2y.jpg"> ' +
        '</div></div></div>'+
      '<div class="panel panel-default"><div class="panel-heading">\n' +
      '    <h3 class="panel-title">魔法学堂</h3>\n' +
      '  </div>\n' +
      '  <div class="panel-body">\n' +
      '    <div class="row">\n' +
      '<div class="col-md-7"> <h4>2、请使用font-face自定义字体，完成如下毛泽东诗词特效：</h4><img class="img-responsive" src="http://ww1.sinaimg.cn/large/6d025b55ly1g6746b6ycdj20tz0j6b29.jpg"> ' +
      '</div></div></div>',5),
      new Task(2,'flex布局及其使用','  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '    <div class="row">\n' +
        '<div class="col-md-6"> <h4>1、请flex布局，实现如图所示的垂直布局特效：</h4><img class="img-responsive" src="http://ww2.sinaimg.cn/large/6d025b55ly1g6748tmxa1j20y50aagte.jpg"> ' +
        '</div></div></div>',5),
      new Task(3,'CSS3过渡及应用','  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '<h4>请使用CSS过渡语法，在鼠标悬浮在左侧红色矩形时，实现矩形的放大效果，如右图所示：</h4>'+
        '    <div class="row">\n' +
        '<div class="col-md-6"> <img class="img-responsive" src="http://ww4.sinaimg.cn/large/6d025b55ly1g674gn9jokj20230230dm.jpg"></div> ' +
        '<div class="col-md-6"> <img class="img-responsive" src="http://ww4.sinaimg.cn/large/6d025b55ly1g674gzsy5tj20490240eq.jpg"> </div>' +
        '</div></div>',5),
      new Task(4,'CSS3动画及应用','  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '<h4>请使用CSS动画语法，实现小球的加载动画，如下图所示：</h4>'+
        '    <div class="row">\n' +
        '<div class="col-md-6"> <img class="img-responsive" src="http://ww3.sinaimg.cn/large/6d025b55ly1g674ne7wmog205c02s762.gif"></div> ' +

        '</div></div></div>'+
      '  <div class="panel panel-default"><div class="panel-heading">\n' +
      '    <h3 class="panel-title">挑战题</h3>\n' +
      '  </div>\n' +
      '  <div class="panel-body">\n' +
      '<h4>请使用CSS动画语法，实现方块的加载动画，如下图所示：</h4>'+
      '    <div class="row">\n' +
      '<div class="col-md-6"> <img class="img-responsive" src="http://ww3.sinaimg.cn/large/6d025b55ly1g674p4l0p6g205604k0tg.gif"></div> ' +

      '</div></div></div>'+
      '  <div class="panel panel-default"><div class="panel-heading">\n' +
      '    <h3 class="panel-title">挑战题</h3>\n' +
      '  </div>\n' +
      '  <div class="panel-body">\n' +
      '<h4>请使用CSS动画语法，实现波浪式的加载动画，如下图所示：</h4>'+
      '    <div class="row">\n' +
      '<div class="col-md-6"> <img class="img-responsive" src="http://ww4.sinaimg.cn/large/6d025b55ly1g674rptcfug2030022abj.gif"></div> ' +

      '</div></div></div>',5),
      // new Task(5,'揭秘网页多媒体','<img src="http://ww1.sinaimg.cn/large/6d025b55ly1g57g690hfqj208e01mq2r.jpg">',5),
      new Task(5,'揭秘网页多媒体',
        '  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂:嵌入音频文件</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '<h4>请使用音频标签及其相关属性，在页面中嵌入声音，效果如下所示：</h4>'+
        '<a href="https://www.bootcss.com/p/layoutit/" class=" btn  btn-success"> 声音来源:http://www.w3school.com.cn/i/song.ogg</a><br>'+
        '    <div class="row">\n' +
        '<div class="col-md-6"> <audio src="http://www.w3school.com.cn/i/song.ogg" controls="controls">\n' +
        'Your browser does not support the audio element.\n' +
        '</audio></div> ' +

        '</div></div></div>'+
        '  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂：嵌入视频文件</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '<h4>请使用视频标签及其相关属性，在页面中嵌入视频，效果如下所示：</h4>'+
        '<a href="#" class=" btn  btn-primary"> 视频来源：http://www.w3school.com.cn/i/movie.ogg</a><br>'+
        '    <div class="row">\n' +
        '<div class="col-md-6"> ' +
        '<video width="320" height="240" controls="controls">\n' +
        '  <source src="http://www.w3school.com.cn/i/movie.ogg" type="video/ogg">\n' +
        '  <source src="/i/movie.mp4" type="video/mp4">\n' +
        'Your browser does not support the video tag.\n' +
        '</video>'+
        '</div> ' +

        '</div></div></div>'+
        '  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂：嵌入flash文件</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '<h4>请使用object标签及其相关属性，实现页面中嵌入flash，效果如下所示：</h4>'+
        '<a href="#" class=" btn  btn-primary"> https://www.runoob.com/try/demo_source/helloworld.swf</a>'+
        '    <div class="row">\n' +
        '<div class="col-md-6"> ' +
          '<img src="http://ww1.sinaimg.cn/large/6d025b55ly1g675q7jxnvg20qk0dktcr.gif" class="img-responsive"> '+
        // '<object width="400" height="400" data="https://www.runoob.com/try/demo_source/helloworld.swf" type="application/x-shockwave-flash"></object> '+
        // '<object width="600" height="400" data="https://www.runoob.com/try/demo_source/helloworld.swf" type="application/x-shockwave-flash">\n' +
        // '</object>' +
        '</div></div></div>' ,5),

      // new Task(5,"揭秘网页多媒体",'<div class="nav-tabs-custom">\n' +
      //   '            <ul class="nav nav-tabs">\n' +
      //   '              <li class=""><a href="#tab_1" data-toggle="tab" aria-expanded="true">子任务:嵌入音频</a></li>\n' +
      //   '              <li class=""><a href="#tab_2" data-toggle="tab" aria-expanded="false">子任务:嵌入视频</a></li>\n' +
      //   '              <li class="active"><a href="#tab_3" data-toggle="tab">子任务嵌入swf</a></li>\n' +
      //
      //   '              <li class="pull-right"><a href="#" class="text-muted"><i class="fa fa-gear"></i></a></li>\n' +
      //   '            </ul>\n' +
      //   '            <div class="tab-content">\n' +
      //   '              <div class="tab-pane " id="tab_1">\n' +
      //   '<h4 >请按照上图完成音频的制作</h4>'+
      //   '<ol>'+
      //   '<li>组织并放置声音文件</li>'+
      //   '<li>创建标签audio</li>'+
      //   '<li>指定src引用文件</li>'+
      //   '</ol>'+
      //   '                 <audio src="http://www.w3school.com.cn/i/song.ogg" controls="controls">\n' +
      //   'Your browser does not support the audio element.\n' +
      //   '</audio>' +
      //   '              </div>\n' +
      //   '              <!-- /.tab-pane -->\n' +
      //   '              <div class="tab-pane " id="tab_2">\n' +
      //   '<video width="320" height="240" controls="controls">\n' +
      //   '  <source src="http://www.w3school.com.cn/i/movie.ogg" type="video/ogg">\n' +
      //   '  <source src="/i/movie.mp4" type="video/mp4">\n' +
      //   'Your browser does not support the video tag.\n' +
      //   '</video>'+
      //   '              </div>\n' +
      //
      //   '            </div>\n' +
      //   '            <!-- /.tab-content -->\n' +
      //   '              <!-- /.tab-pane -->\n' +
      //   '              <div class="tab-pane active " id="tab_3">\n' +
      //   '<embed src="https://www.w3cschool.cn/statics/demosource/bookmark.swf" width="800" height="600">'+
      //    '<object width="400" height="50" data="https://www.w3cschool.cn/statics/demosource/bookmark.swf"></object>'+
      //   // '                 <object width="400" height="50" data="https://www.w3cschool.cn/statics/demosource/bookmark.swf"></object>'+
      //   '              </div>\n' +
      //
      //   '            </div>\n' +
      //   '            <!-- /.tab-content -->\n' +
      //   '          </div>',5),

      new Task(6,'Bootstrap响应式页面之栅格系统','  <div class="panel panel-default"><div class="panel-heading">\n' +
        '    <h3 class="panel-title">魔法学堂</h3>\n' +
        '  </div>\n' +
        '  <div class="panel-body">\n' +
        '<h4>请使用Bootstrap可视化工具，完成如下效果图的设置：</h4>'+
        '<a href="https://www.bootcss.com/p/layoutit/" class=" btn  btn-primary"> 打开Bootstrap可视化布局工具</a>'+
        '    <div class="row">\n' +
        '<div class="col-md-6"> <img class="img-responsive" src="http://ww4.sinaimg.cn/large/6d025b55ly1g67514o44zj20w40lmtj3.jpg"></div> ' +

        '</div></div></div>',5)
    ]),
    new Lab(8, '真实网站开发','完成如下操作',10,[
      new Task(1,'综合案例——新疆文旅项目',''+
      '<div class="panel panel-default">\n' +
      '  <div class="panel-heading">\n' +
      '    <h3 class="panel-title">魔法学堂</h3>\n' +
      '  </div>\n' +
      '  <div class="panel-body">\n' +
      '    <div class="row">\n' +
      '       <div class="col-md-12"><img src="https://tva1.sinaimg.cn/large/e6c9d24ely1h5avk6yiajj20u00vdjwc.jpg" width="100%"></div> \n' +
      '       </div>'+
      '  </div>\n' +
      '</div>',5)
      // new Task(1,'综合案例——排版','描述1',5),
      // new Task(2,'综合案例——表格组件的使用','描述2',5),
      // new Task(3,'综合案例——表单组件的使用','描述2',5),
      // new Task(4,'综合案例——辅助工具的使用','描述2',5),
      // new Task(5,'综合案例——Less/Sass语法使用','描述2',5),
      // new Task(6,'综合案例——460页面头部设计使用','描述2',5),
      // new Task(7,'综合案例——460页面剩余设计使用','描述2',5),
      // new Task(8,'综合案例——650页面设计实现','描述2',5),
      // new Task(9,'综合案例——950页面主题设计使用','描述2',5),
      // new Task(10,'综合案例——1450页面主题设计使用','描述2',5),
      // new Task(11,'综合案例——网站上传和发布','描述2',5)
    ]),
];
